export const AI_PROFILE_SUMMARY_RESULT_MODAL = 'aiProfileSummaryResultModal'
export const DIALOG_ANALYTICS_LABEL = 'ai_suggestion_dialog'
